import { BackButton, Banner, Card, CardText, LinkButton, SubmitBar, Toast } from "@egovernments/digit-ui-react-components";
import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";

const EDCRAcknowledgement = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { resetFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    if (props?.data?.type == "ERROR" && !showToast) setShowToast(true);
  }, [props?.data?.data]);

  const clearAllData = () => {
    resetFormMTDocs();
    Digit?.SessionStorage.del("FORM12_CURRENT_TAB");
    Digit?.SessionStorage.del("ScrutinyDetails");
    Digit?.SessionStorage.del("EDCR_CREATE");
    Digit?.SessionStorage.del("FASTPAS_ID");
    sessionStorage.removeItem("currentCity");
    sessionStorage.removeItem("currLocality");
    sessionStorage.removeItem("currVillage");
  };
  useEffect(() => {
    const handleBackButton = () => {
      clearAllData();
    };
    window.addEventListener("popstate", handleBackButton);
    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  });
  if (props?.data?.type == "ERROR") {
    return (
      <Card style={{ padding: "0px" }}>
        <Banner
          message={t(`${props?.data?.data}`)}
          applicationNumber={""}
          info={""}
          successful={false}
          infoStyles={{ fontSize: "18px", lineHeight: "21px", fontWeight: "bold", textAlign: "center", padding: "0px 15px" }}
          applicationNumberStyles={{ fontSize: "24px", lineHeight: "28px", fontWeight: "bold", marginTop: "10px" }}
          style={{ width: "100%", padding: "10px" }}
        />
        <div style={{ padding: "10px", paddingBottom: "10px" }}>
          <Link to={`/digit-ui/citizen`}>
            <SubmitBar label={t("CORE_COMMON_GO_TO_HOME")} onSubmit={clearAllData} />
          </Link>
        </div>
        {showToast ? <Toast error={"error"} label={t(`${props?.data?.data}`)} onClose={() => setShowToast(null)} isDleteBtn={true} /> : null}
      </Card>
    );
  }

  sessionStorage.setItem("isPermitApplication", true);
  sessionStorage.setItem("isEDCRDisable", JSON.stringify(true));
  const edcrData = props?.data?.[0];
  const isRescrutiny = edcrData?.planDetail?.applicationScrutinyType;
  const isCompetence = edcrData?.planDetail?.roleCompetence;
  const [bpaLinks, setBpaLinks] = useState({});
  const state = Digit.ULBService.getStateId();
  const isMobile = window.Digit.Utils.browser.isMobile();
  const { data: homePageUrlLinks, isLoading: homePageUrlLinksLoading } = Digit.Hooks.obps.useMDMS(state, "BPA", ["homePageUrlLinks"]);
  const { isMdmsLoading, data: mdmsData } = Digit.Hooks.obps.useMDMS(state, "BPA", ["RiskTypeComputation"]);

  useEffect(() => {
    if (!homePageUrlLinksLoading && homePageUrlLinks?.BPA?.homePageUrlLinks?.length > 0) {
      let uniqueLinks = [];
      homePageUrlLinks?.BPA?.homePageUrlLinks?.map((linkData) => {
        if (linkData?.applicationType === edcrData?.appliactionType && linkData?.serviceType === edcrData?.applicationSubType) {
          setBpaLinks({
            linkData: linkData,
            edcrNumber: edcrData?.edcrNumber,
          });
        }
      });
    }
  }, [!homePageUrlLinksLoading]);

  const printReciept = async () => {
    var win = window.open(edcrData.planReport, "_blank");
    if (win) {
      win.focus();
    }
  };
  const downloadPlandiagram = async () => {
    var win = window.open(edcrData.updatedDxfFile, "_blank");
    if (win) {
      win.focus();
    }
  };

  const routeToForm12 = async () => {
    sessionStorage.setItem("clickOnBPAApplyAfterEDCR", true);
    isRescrutiny
      ? history.replace(`/digit-ui/citizen/obps/services/mapSubmissionPortal/${edcrData?.applicationId}`)
      : history.replace(`/digit-ui/citizen/obps/services/mapSubmissionPortal`);
  };
  const routeToPurchasable = async () => {
     history.replace(`/digit-ui/citizen/obps/services/purchasablePortal`);
  };
  const routeToMapSubmission = async () => {
    history.replace(`/digit-ui/citizen/obps/services/mapSubmissionPortal`);
  };

  return (
    <div>
      {edcrData?.status === "Accepted" ? (
        <Card style={{ padding: "0px" }}>
          <BackButton />
          <Banner
            message={t("EDCR_ACKNOWLEDGEMENT_SUCCESS_MESSAGE_LABEL")}
            applicationNumber={edcrData?.edcrNumber}
            info={t("EDCR_SCRUTINY_NUMBER_LABEL")}
            successful={true}
            infoStyles={{ fontSize: "18px", lineHeight: "21px", fontWeight: "bold", textAlign: "center", padding: "0px 15px" }}
            applicationNumberStyles={{ fontSize: "24px", lineHeight: "28px", fontWeight: "bold", marginTop: "10px" }}
            style={{ width: "100%", padding: "10px" }}
          />
          <Box sx={{ padding: "0 2rem 2rem" }}>
            <CardText style={{ padding: "0px 8px", marginBottom: "1rem" }}>{`${t("EDCR_SCRUTINY_NUMBER_LABEL")} - ${edcrData?.edcrNumber}`}</CardText>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "start" }}>
              <div className="primary-label-btn" style={{ marginLeft: "unset", marginBottom: "1rem", padding: "0px 8px" }} onClick={printReciept}>
                <svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19.3334 8H14V0H6.00002V8H0.666687L10 17.3333L19.3334 8ZM0.666687 20V22.6667H19.3334V20H0.666687Z" fill="#a82227" />
                </svg>
                {t("EDCR_DOWNLOAD_SCRUTINY_REPORT_LABEL")}
              </div>
              {/* <div className="primary-label-btn" style={{ marginLeft: "3rem", marginBottom: "1rem", padding: "0px 8px" }} onClick={downloadPlandiagram}>
                <svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19.3334 8H14V0H6.00002V8H0.666687L10 17.3333L19.3334 8ZM0.666687 20V22.6667H19.3334V20H0.666687Z" fill="#a82227" />
                </svg>
                {t("Download Drawing")}
              </div> */}
            </div>
            <div style={{ padding: "0px 10px" }}>
              {/* <div style={{display: 'flex', gap: '1rem'}}>
            <Link to={{pathname: `/digit-ui/citizen/obps/${bpaLinks?.linkData?.flow?.toLowerCase()}/${edcrData?.appliactionType?.toLowerCase()}/${edcrData?.applicationSubType?.toLowerCase()}/basic-details`, state: bpaLinks}} replace>
              <SubmitBar label={t("BPA_APPLY_FOR_BPA_LABEL")} onSubmit={() => (sessionStorage.setItem("clickOnBPAApplyAfterEDCR",true))}/>
              <CardText className="button-sub-text"  style={{fontSize: "14px", lineHeight: "16px", margin: "4px 10px 10px 50px", fontWeight: "400", color: "#0B0C0C"}}>{t("BPA_FOR_NEW_CONSTRUCTION_LABEL")}</CardText>
            </Link>
            </div> */}
              {/* <InfoBox>
                Please download the <strong>Drawing</strong>, add your <strong>Digital Signature</strong> and then upload the signed file to the Document Section <span className="mandatory">*</span>.
              </InfoBox> */}
              <SubmitBar label={t("Apply For Map Submission")} onSubmit={routeToForm12} />
              {/* {!isCompetence &&  <CardText style={{ padding: "0px 8px", marginBottom: "1rem"}}>{`${t("You are not eligible to apply for Map Submission. Please ensure you meet the required competencies or contact support for more information.")}`}</CardText>
          } */}

              <div style={{ width: "fit-content" }}>
                <Link to={`/digit-ui/citizen/profile`}>
                  <LinkButton label={t("CORE_COMMON_GO_TO_HOME")} onClick={clearAllData} />
                </Link>
              </div>
            </div>
          </Box>
        </Card>
      ) : (
        <Card style={{ padding: "0px" }}>
          <BackButton />
          <Banner
            message={t("EDCR_ACKNOWLEDGEMENT_REJECTED_MESSAGE_LABEL")}
            applicationNumber={""}
            info={""}
            successful={false}
            infoStyles={{ fontSize: "18px", lineHeight: "21px", fontWeight: "bold", textAlign: "center", padding: "0px 15px" }}
            applicationNumberStyles={{ fontSize: "24px", lineHeight: "28px", fontWeight: "bold", marginTop: "10px" }}
            style={{ width: "100%", padding: "10px" }}
          />
          <CardText style={{ padding: "0px 8px", marginBottom: "10px" }}>{t("EDCR_ACKNOWLEDGEMENT_REJECTED_MESSAGE_TEXT_LABEL")}</CardText>
          <CardText style={{ padding: "0px 8px", marginBottom: "10px" }}>{`${t("EDCR Number")} - ${edcrData?.applicationNumber}`}</CardText>
          <div className="primary-label-btn d-grid" style={{ marginLeft: "unset", marginBottom: "10px", padding: "0px 8px" }} onClick={printReciept}>
            <svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.3334 8H14V0H6.00002V8H0.666687L10 17.3333L19.3334 8ZM0.666687 20V22.6667H19.3334V20H0.666687Z" fill="#a82227" />
            </svg>
            {t("EDCR_DOWNLOAD_SCRUTINY_REPORT_LABEL")}
          </div>
          <div style={{ width: "fit-content", padding: "10px", boxSizing: "border-box" }}>
            <Link to={`/digit-ui/citizen/profile`}>
              <SubmitBar label={t("CORE_COMMON_GO_TO_HOME")} onSubmit={clearAllData} />
            </Link>
          </div>
        </Card>
      )}
    </div>
  );
};
export default EDCRAcknowledgement;
